export default function checkUserProfile(user, profile) {
  const { name: userProfileName } = user.profiles[0];
  if (profile === userProfileName) return true;

  return false;
}
